import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const CustomDatePicker = ({ value, onChange, field, error }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={field.label}
        value={value && dayjs(value)}
        onChange={onChange}
        slotProps={{
          textField: {
            fullWidth: true,
            required: field.required,
            error: error,
            margin: "dense",
            helperText: error ? "This field is required" : "",
            size: "small",
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
